<template>
    <div class="page-passport">
        <a href="/" class="logo">
            <img src="@/assets/img/register/logo@2x.png" />
        </a>
        <div class="page-box-layout">
            <div class="account-selection" v-if="formerEmployees">
                <div class="title">无法登录企业账号</div>
                <p>您的手机号已经无法登录企业账号，如果您还想继续使用秀动发行发行作品，可以点击注册，注册一个个人发行账号</p>
                <el-button class="submit-btn" :loading="loginLoading"
                    @click.prevent="formerEmployees = false; submitRegister();" type="base">
                    注册秀动发行
                </el-button>
            </div>
            <template v-else>
                <template v-if="multipleAccount.length != 2">
                    <div class="left">
                        <div class="form-box">
                            <div class="tab-box">
                                <span class="title">登录秀动发行</span>
                            </div>
                            <el-form :model="formData" :rules="rules" hide-required-asterisk ref="formData"
                                label-position="top">
                                <!-- 登录 -->
                                <template>
                                    <el-form-item prop="telephone" label="手机号">
                                        <el-input v-model="formData.telephone" placeholder="请输入手机号"></el-input>
                                    </el-form-item>
                                    <el-form-item prop="telephoneCode" label="验证码">
                                        <div class="input-with-button">
                                            <el-input v-model="formData.telephoneCode" placeholder="请输入短信验证码"></el-input>
                                            <el-button native-type="button" type="text" @click="getCode()"
                                                :disabled="codeText > 0 ? true : false">
                                                {{ codeText > 0 ? `（${codeText}s）` : '立即获取' }}
                                            </el-button>
                                        </div>
                                    </el-form-item>
                                </template>
                                <!-- 注册 -->
                                <div class="protocol-box">
                                    <el-checkbox v-model="checked">
                                        我已阅读
                                        <el-button type="text" class="base" @click="openWin">《秀动发行隐私协议》</el-button>
                                    </el-checkbox>
                                </div>

                                <el-form-item class="btn-box">
                                    <el-button class="submit-btn" v-if="!sign" type="base" round @click.prevent="submit()"
                                        :loading="loginLoading" native-type="submit">
                                        立即登录
                                    </el-button>
                                    <el-button class="submit-btn" v-if="sign" type="base" round
                                        @click.prevent="submitRegister()" :loading="loginLoading" native-type="submit">
                                        立即注册
                                    </el-button>
                                    <el-button class="weixin-btn" @click="openWeixin()" round plain>
                                        <i class="icon-weixin"></i>
                                        使用微信登录
                                    </el-button>
                                </el-form-item>
                            </el-form>
                        </div>
                    </div>
                    <div class="describe">
                        <router-link class="slogan" to="/"><img src="@/assets/img/logo-en.png"
                                alt="showstart-release" /></router-link>
                        <p>Every piece of music is a classic</p>
                        <p>Be there every time</p>
                        <div class="login-img"></div>
                    </div>
                </template>
                <div class="account-selection" v-else>
                    <!-- 账号选择 -->
                    <div class="title">选择进入的账号</div>
                    <p>/ 这个世界需要你的音乐 /</p>
                    <el-radio-group v-model="loginType">
                        <el-radio :label="1" border>
                            个人
                            <strong>个人账号 Personal account</strong>
                        </el-radio>
                        <el-radio :label="3" border style="margin-left: 0px; margin-top: 10px">
                            企业
                            <strong>企业账号 Enterprise account</strong>
                        </el-radio>
                    </el-radio-group>
                    <el-button class="submit-btn" type="base" round @click.prevent="loginNext()" :loading="loginLoading"
                        native-type="submit">
                        进入账号
                    </el-button>
                </div>
            </template>
            <el-dialog :visible.sync="weixinVisible" modal-append-to-body append-to-body :show-close="false"
                :close-on-press-escape="false" custom-class="weixin-login" width="300px">
                <div class="dialog-body">
                    <div class="back">
                        <el-button @click="weixinVisible = false" type="text">手机验证码登录</el-button>
                    </div>
                    <el-image :src="weixinImage">
                        <div slot="error" class="image-slot">
                            <i class="el-icon-loading"></i>
                        </div>
                    </el-image>
                    <h5>微信登录</h5>
                    <p>请使用微信扫描二维码登录秀动发行</p>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import ls from 'local-storage';
const cpLoginType = 1; // 登录平台标示

export default {
    data() {
        return {
            formData: {
                telephone: '',
                telephoneCode: '',
                cpLoginType,
            },
            rules: {
                telephone: [{ required: true, message: '请输入手机号' }, { validator: this.$utils.validatePhone }],
                telephoneCode: [{ required: true, message: '请输入短信验证码' }],
            },
            codeText: 0,
            loginLoading: false,
            captcha: null,
            checked: false,
            redirect: this.$route.query.redirect || '/manage',
            weixinVisible: false,
            verifyRegister: true,
            weixinImage: '',
            identifier: '',
            wxLoginTime: 0,
            loginType: 1, // 登录账号类型
            sign: '', // 注册签名  如果有值为需要注册
            formerEmployees: false, // 是否是离职员工
            multipleAccount: [], // 是否是多个账号
            timeInterval: null
        };
    },
    mounted() {
        this.loadCaptcha();
    },
    methods: {
        // 提取加载腾讯验证码的方法
        loadCaptcha() {
            this.$utils.loadScript({ id: 'tcaptcha', url: 'https://turing.captcha.qcloud.com/TCaptcha.js' }, () => {
                // eslint-disable-next-line no-undef
                this.captcha = new TencentCaptcha(this.$config.CaptchaAppId, (res) => {
                    if (res.ret === 0) {
                        this.getCodeEvent(res);
                    }
                });
            });
        },
        //获取短信验证码
        getCode() {
            this.$refs['formData'].validateField(['telephone'], (err) => {
                if (!err) this.captcha.show();
            });
        },
        // 发送短信验证码
        async getCodeEvent({ randstr, ticket }) {
            const { telephone } = this.formData;
            const response = await this.$request.post('/code/add/sms', {
                telephone,
                randstr: encodeURIComponent(randstr),
                ticket: encodeURIComponent(ticket),
            });
            const { msg, state } = response.data;
            if (!state) return this.$message.error(msg || '验证码发送失败');
            this.formData.telephoneCode = '';
            this.codeText = 59;
            // 倒计时
            this.timeInterval = setInterval(() => {
                if (this.codeText < 1) {
                    clearInterval(this.timeInterval);
                    this.timeInterval = null;
                }
                this.codeText -= 1;
            }, 1000);
        },
        openWin() {
            window.open('/help?key=privacyagreement');
        },
        async getWXlogin() {
            if (!this.weixinVisible) return;
            const res = await this.$request({
                url: '/org/checkMiniAppLoginStatus',
                method: 'GET',
                params: { identifier: this.identifier, channelId: ls.get('channelId') || null, invitationCode: ls.get('invitationCode') || '' },
            });
            const { state, msg, result } = res.data;
            if (!state) return this.$message.error(msg || '请求失败');
            const { loginStatus, userLoginVo } = result;
            if (loginStatus === 1) return this.openPage(userLoginVo);
            if (loginStatus === 2 || loginStatus === 3) {
                this.weixinVisible = false;
                return this.$message.error('微信登录失败，请重新尝试登录');
            }
            if (this.wxLoginTime > new Date().getTime()) {
                const timeOut = setTimeout(() => {
                    clearTimeout(timeOut);
                    this.getWXlogin();
                }, 2000);
            } else {
                this.weixinVisible = false;
                this.$message.error('微信登录超时，请重新尝试微信登录');
            }
        },
        async openWeixin() {
            this.weixinVisible = true;
            const res = await this.$request({
                url: '/org/wxMiniAppCode',
                method: 'GET',
            });
            const { state, msg, result } = res.data;
            if (!state) return this.$message.error(msg || '请求失败');
            this.weixinImage = result.code;
            this.identifier = result.identifier;
            this.wxLoginTime = new Date().getTime() + 660 * 1000; // 10分钟后为轮询超时
            this.getWXlogin();
        },
        openPage(result) {
            this.$store.commit('SET_USERINFO', result || null);
            if (result.isVerify == 0) {
                this.$router.push('/manage/dashboard');
            } else {
                this.$router.push(this.redirect);
            }
        },
        submit() {
            this.$refs['formData'].validate(async (valid) => {
                if (valid) this.login();
            });
        },
        async login() {
            if (this.checked === false) return this.$message.error('请仔细阅读《秀动发行隐私协议》后，进行勾选');
            this.loginLoading = true;
            const form = JSON.parse(JSON.stringify(this.formData));
            const res = await this.$request({
                url: '/org/showstart_login',
                method: 'POST',
                data: form,
                params: form,
                formData: false,
            });
            const { state, msg, result, code } = res.data;
            this.loginLoading = false;
            if (!state) {
                if (code == 'cp.user.depart.login') return (this.formerEmployees = true); // 离职员工显示
                return this.$message.error(msg || '请求失败');
            }
            const { regStep, depart, ambiguity, personalName, enterpriseName, sign } = result;
            // 未注册 需要注册
            if (regStep === 0) {
                this.sign = sign;
                // 离职员工需要重新注册
                if (depart === 1) return (this.formerEmployees = true);
                return this.submitRegister();
            }
            // 多账号员工
            if (ambiguity === 1) return (this.multipleAccount = [personalName, enterpriseName]);
            this.openPage(result);
        },
        // 账号登录选择
        async loginNext() {
            this.loginLoading = true;
            const response = await this.$request.post('/org/loginByCacheTelephone', {
                telephone: this.formData.telephone,
                idType: this.loginType,
                cpLoginType,
            });
            const { state, msg, result } = response.data;
            this.loginLoading = false;
            if (!state) return this.$message.error(msg || '登录失败');
            this.openPage(result);
        },
        //登录、注册请求
        submitRegister() {
            this.loginLoading = true;
            const form = JSON.parse(JSON.stringify(this.formData));
            form.channelId = ls.get('channelId') || null;
            form.invitationCode = ls.get('invitationCode') || '';
            if (this.sign) {
                form.identifier = this.sign;
                // delete form.telephoneCode;
            }
            form.userSource = 1;
            this.$request({
                url: '/org/showstart/register',
                method: 'POST',
                data: form,
                params: form,
                formData: false,
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (!state) return this.$message.error(msg || '请求失败');
                    this.openPage(result);
                })
                .catch(() => {
                    this.$message.error('请求错误');
                })
                .finally(() => {
                    this.loginLoading = false;
                });
        },
    },
};
</script>

<style lang="scss">
.page-passport {
    min-height: 100vh;
    color: $-text-50;
    background: url('~@/assets/img/bg.png') #000 center center no-repeat;
    background-size: cover;
    position: relative;

    .account-selection {
        width: 500px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        text-align: center;

        .title {
            font-size: 44px;
            color: $-text-50;
            line-height: 44px;
            font-style: normal;
        }

        p {
            font-size: 14px;
            color: #909399;
            line-height: 24px;
            font-style: normal;
            margin-top: 20px;
        }

        .el-radio-group {
            display: block;
            margin-top: 60px;
        }

        .submit-btn {
            width: 370px;
            margin-top: 60px;
            height: 50px;
            line-height: 30px;
        }

        .el-radio {
            color: $--color-white;
            background: #2a2a2a;
            border-radius: 10px;
            height: 100px;
            line-height: 88px;
            padding: 0px 30px;
            text-align: left;
            width: 100%;
            border-color: #2a2a2a;
            color: #979797;
            font-weight: bold;
            position: relative;

            strong {
                position: absolute;
                top: 0px;
                right: 20px;
                top: 0px;
            }

            .el-radio__inner {
                background: transparent;
                border-color: #979797;
                border-width: 2px;
            }

            &.is-checked {
                border-color: $--color-base;
                background: $--color-base;

                .el-radio__label {
                    color: $-text-50;
                }

                .el-radio__inner {
                    border-color: $-text-50;
                }
            }
        }
    }

    .protocol-box {
        margin-top: 40px;
        line-height: 20px;

        .el-checkbox__inner {
            background: transparent;
            border-color: $-text-500;
        }

        .el-button,
        .el-checkbox__label {
            color: $-text-500 !important;
        }
    }

    .icon-weixin {
        width: 20px;
        height: 16px;
        background: url('~@/assets/img/wechat.png') center no-repeat;
        display: inline-block;
        position: relative;
        top: 3px;
    }

    &::before {
        content: '';
        width: 699px;
        height: 402px;
        background: url('~@/assets/img/big-arrow.png') 30px center no-repeat;
        background-size: 100%;
        position: absolute;
        right: 0;
        bottom: 60px;
        z-index: 1;
    }

    .page-box-layout {
        display: flex;
        position: absolute;
        z-index: 10;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        min-height: 450px;

        .left,
        .describe {
            flex: 1;
        }
    }

    .logo {
        padding: 30px;
        display: block;

        img {
            width: 100px;
        }
    }

    .describe {
        font-size: 14px;
        font-weight: bold;
        color: #ffffff;
        line-height: 22px;

        .slogan {
            padding-bottom: 36px;
            display: block;

            img {
                width: 399px;
            }
        }

        p {
            display: block;
        }
    }

    .form-box {
        width: 370px;

        .tab-box {
            display: inline-block;
            margin: 0 0 20px 0;
            position: relative;

            .title {
                font-size: 20px;
                color: $-text-50;
                line-height: 20px;
                text-align: left;
                font-style: normal;
            }
        }

        .el-form {
            .el-form-item__label {
                display: none;
            }

            .el-input__inner {
                border-radius: 0;
                border: 0;
                padding: 0;
                color: $-text-50;
                font-size: 16px;
                height: 50px;
                line-height: 50px;
                transition: all 0.6s ease-in-out;
                font-weight: bold;
                background: #2a2a2a;
                border-radius: 10px;
                padding: 0 20px;

                &::placeholder {
                    color: $-text-600;
                    font-weight: 500;
                }
            }

            .el-form-item__error {
                position: absolute;
                left: 380px;
                top: 16px;
                white-space: nowrap;
            }

            .input-with-button {
                position: relative;

                .el-button {
                    position: absolute;
                    right: 20px;
                    top: 10px;
                    color: #fff;
                }
            }
        }

        .btn-box {
            margin-top: 40px;
            text-align: left;

            p {
                text-align: center;
                line-height: 12px;
                margin: 20px 0;
            }

            .el-button {
                height: 50px;
                border-radius: 10px;
                line-height: 26px;
                width: 100%;
            }

            .weixin-btn {
                background: transparent;
                border: 1px solid $--button-default-font-color;
                color: $-text-500;
                margin-top: 20px;
                margin-left: 0px;
            }
        }
    }
}
</style>
